// Change #100420 - AmountVatPercentage is DECIMAL(20,6), so an existing line
// arrives as "20.000000" and the line editors put all six places in the VAT box.
// Show it to 2dp instead ("20.00", "17.50"). Blank and non-numeric values (a
// half-typed entry) are passed through untouched.
export const formatVatPercent = (value) => {
  if (value === null || value === undefined) return "";
  const raw = String(value).replace("%", "").trim();
  if (raw === "") return "";
  const asNumber = Number(raw);
  return Number.isNaN(asNumber) ? raw : asNumber.toFixed(2);
};
